import { EntityReference } from '@hud/portal-dtos/webapp-common.dto';
import { useGlobalQueryString } from './useGlobalFilter';
import { useMemo } from 'react';

export function useServiceFilter(service: EntityReference) {
  const globalFilters = useGlobalQueryString();
  const currentFilters = useMemo(() => {
    const searchParams = new URLSearchParams();
    searchParams.set('service', service.id.toString());
    return `${globalFilters}&${searchParams.toString()}`;
  }, [globalFilters, service]);
  return currentFilters;
}
